import React from "react"

import SEO from "../components/common/SEO"

import AboutHero from "../components/about/AboutHero"
import MissionSection from "../components/about/MissionSection"
import SpaExperience from "../components/about/SpaExperience"
import TeamSection from "../components/about/TeamSection"

export default function About() {
  return (
    <>
      {/* SEO */}
      <SEO
        title="A Propos De Nous | Centre Spa Land Saphir Palace Hammamet Tunisia"
        description="Découvrez notre centre de spa de luxe, notre mission, notre vision, notre équipe d'experts et notre expérience bien-être."
        keywords="À propos des spas, spas en Tunisie, centre de bien-être hammam, équipe de spa"
        url="https://www.yourdomain.com/about"
      />

      <main className="overflow-x-hidden">
        <AboutHero />
        <MissionSection />
        <SpaExperience />
        <TeamSection />
      </main>
    </>
  )
}